"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseColumnTypeParams = exports.dataTypes = exports.columnTypeMap = exports.withParamsColumnTypeMap = exports.autodetectTypeMap = void 0;
/**
 * Autodetect Types - type isn't specified in typeorm, lets it detect from Reflection
 */
exports.autodetectTypeMap = new Map([
    ['number', 'number'],
    ['string', 'string'],
    ['boolean', 'boolean'],
    // datetime isn't a type in Postgres, this is to differentiate it from 'date' in the autoselect dropdown
    ['datetime', 'Date']
]);
/**
 * Types that has () in them. This is used to display them as options in autoselect and for comparing
 * if a column type can accept a param.
 */
exports.withParamsColumnTypeMap = new Map([
    ['character varying()', 'string'],
    ['character()', 'string'],
    ['decimal()', 'number'],
    ['numeric()', 'number']
]);
exports.columnTypeMap = new Map([
    ...Array.from(exports.autodetectTypeMap.entries()),
    // Numeric Types
    ['smallint', 'number'],
    ['integer', 'number'],
    ['bigint', 'number'],
    ['decimal', 'number'],
    ['numeric', 'number'],
    ['real', 'number'],
    ['double precision', 'number'],
    // Character Types
    ['character varying', 'string'],
    ['character', 'string'],
    ['text', 'string'],
    // Date/Time Types
    ['date', 'string'],
    ['time', 'string'],
    ['time with time zone', 'string'],
    ['timestamp', 'Date'],
    ['timestamp with time zone', 'Date'],
    // UUID Types
    ['uuid', 'string'],
    // JSON Types
    ['json', 'object'],
    ['jsonb', 'object']
]);
exports.dataTypes = [
    ...Array.from(exports.columnTypeMap.keys()),
    ...Array.from(exports.withParamsColumnTypeMap.keys())
].sort();
/**
 * Parse a column type string with params like numeric() or without params like text.
 * @returns an tuple with the first element as the parsed ColumnType and the second
 *          element is the params.
 */
function parseColumnTypeParams(columnType) {
    // matches 'numeric(7,2)' and captures 'numeric' and '7,2'
    // will also match just 'numeric' for types that don't have params
    const COLUMN_TYPE_REGEX = /([^]+)(?:\((.*)\))?/;
    const [type, params] = columnType.match(COLUMN_TYPE_REGEX) || [];
    return [type, ((params === null || params === void 0 ? void 0 : params.split(',')) || []).map(p => p.trim())];
}
exports.parseColumnTypeParams = parseColumnTypeParams;
/**
 * Checks if an object property belongs in the interface of ColumnCommonOptions
 */
// export function isAColumnCommonOption(
//   property: string
// ): property is keyof ColumnCommonOptions {
//   switch (property as keyof ColumnCommonOptions) {
//     case 'array':
//     case 'comment':
//     case 'default':
//     case 'generated':
//     case 'name':
//     case 'nullable':
//     case 'onUpdate':
//     case 'primary':
//     case 'select':
//     case 'transformer':
//     case 'unique':
//       return true;
//     default:
//       return false;
//   }
// }
//# sourceMappingURL=data-types.js.map